<template>
  <div>
    <p>ChatView</p>
    <ChatbotWrapper
      :context="{ jsonData: mockContext, firstMessage: 'Your portfolio sucks' }"
      socketPath="/ws/agent-chat/"
    />
  </div>
</template>


<script>
import ChatbotWrapper from '@frontend/ui/features/chat/components/ChatbotWrapper.vue';
import mockContext from '@frontend/assets/json/portfolio_checkup/mock_context.json';
export default {
  name: 'ChatView',
  components: { ChatbotWrapper },
  props: [/* Inputs */],
  data() {
    return { mockContext };
  },
  computed: {
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
